import { Panel } from "primereact/panel";
import DataTableSkeleton from "../../../Skeletons/DataTableSkeleton";
import { toSentenceCase } from "../../../../utils/constants";
const StrengthOpportunitiesCard = ({
  headerText,
  itemsData,
  loading,
  calculationValue,
}) => {
  return (
    <Panel className="mt-2 text-start">
      {loading ? (
        <DataTableSkeleton />
      ) : (
        <>
          <h4 className="fw-semibold text-start my-2 text_dark">
            {headerText} ({calculationValue})
          </h4>
          <div
            className="d-flex align-items-center justify-content-end py-2 px-1"
            style={{
              color: "#9E9E9E",
              borderBottom: "1px solid #dee2e6",
              fontSize: "15px",
            }}
          >
            <div className="label-value" style={{ paddingRight: "50px" }}>
              Index
            </div>
          </div>
          {itemsData.length > 0
            ? itemsData
                .sort((a, b) => b.value - a.value)
                .map((item, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center justify-content-between py-2 px-1"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      backgroundColor:
                        (index + 1) % 2 === 0 ? "#f5f5f5" : "#fff",
                      fontSize: "15px",
                    }}
                  >
                    <label className="label-text">
                      <span className="fw-600">{item.labelOne} </span>
                      <span>{item.labelTwo}</span>
                      {item?.isShowAsteriskSign ? "*" : ""}
                      {/* <div>
                        (n={item?.individualBrandBaseSizeVal || 0} XMOT
                        <sup>&reg;</sup> survey)
                      </div> */}
                    </label>
                    <label
                      style={{ paddingRight: "50px" }}
                      className={`label-value ${item.value < 100 ? "text-danger fw-600" : "text-success fw-600"}`}
                    >{`${item.value}`}</label>
                  </div>
                ))
            : null}
        </>
      )}
    </Panel>
  );
};

export default StrengthOpportunitiesCard;
